export default __webpack_public_path__ + "static/media/LearnMain.675f1f0c.jpg";